import { AuthService } from './../auth.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../user.model';
import { UserService } from '../user.service';
import { first } from 'rxjs/operators';
import { BaseEntityListComponent } from '../base-entity-list.component';
import { AssignmentProposal } from '../assignment-proposal.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AssignmentProposalServiceFactory } from '../assignment-proposal.service';

@Component({
  selector: 'app-user-detail-assignment-proposals',
  templateUrl: './user-detail-assignment-proposals.component.html',
  styleUrls: ['./user-detail-assignment-proposals.component.css']
})
export class UserDetailAssignmentProposalsComponent extends BaseEntityListComponent<AssignmentProposal> implements OnInit {

  constructor(private route: ActivatedRoute, private userService: UserService, private authService: AuthService, private router: Router, private snackBar: MatSnackBar, private assignmentProposalServiceFactory: AssignmentProposalServiceFactory) {
    super(AssignmentProposal, assignmentProposalServiceFactory.create(null), snackBar);
  }

  displayedColumns = ["proposalDate", "answerDate", "pending", "answer", "fee"];

  user: User;

  async ngOnInit() {
    if (this.route.snapshot.parent.params.userId) {
      this.user = await this.userService.get(this.route.snapshot.parent.params.userId).pipe(first()).toPromise();
    } else {
      this.user = await this.authService.user$.pipe(first()).toPromise();
    }
    this.list();
  }

  go(assignmentProposal: AssignmentProposal) {
    if (assignmentProposal.pending) {
      this.router.navigate(['/itineraries'], { queryParams: { proposal: assignmentProposal.id } });
    }
  }

  list() {
    this.assignmentProposalServiceFactory.create(null).listForUser(this.user).subscribe((entities: AssignmentProposal[]) => this.dataSource.data = entities);
  }


}
